<template>
    <div class="w-100 white">
        <d-site-contact-assignment
            v-model   = "showAssignmentDialog"
            :label    = "title"
            :company  = "company"
            :company-role = "companyRole"
            :selected = "contacts"
            :onsite   = "onsite"
            :zus      = "zus"
            @assign   = "onAssigned"
        />

        <c-column-header
            class  = "w-100 primary mb-1"
            :label = "title"
        >
            <template v-slot:pre>
                <div class="ml-n2" style="margin-top: -2px">
                    <c-toolbar-button
                        icon     = "mdi-plus"
                        size     = "21"
                        color    = "white"
                        :tooltip = "$t('contact.assign.tooltip')"
                        @click   = "onAssign"
                    />
                </div>
            </template>
        </c-column-header>

        <div class="card-area">
            <c-contact-card
                v-for            = "(contact, index) in contacts"
                :contact         = "contact"
                :key             = "contact.id"
                :edit-contact    = "false"
                :enable-unassign = "true"
                :class           = "index < contacts.length - 1 ? 'mb-3' : ''"
                @dissolve        = "onDissolve"
            />
        </div>
    </div>
</template>

<script>
import CColumnHeader          from "@/modules/core/components/utils/CColumnHeader";
import CContactCard           from "@/modules/msd/company/contact/components/controlls/CContactCard";
import CToolbarButton         from "@/modules/core/components/utils/CToolbarButton";
import DSiteContactAssignment from "@/modules/msd/unit/components/dialog/DSiteContactAssignment";

export default {
    name: "CSiteContactColumn",

    components: {
        DSiteContactAssignment,
        CToolbarButton,
        CContactCard,
        CColumnHeader
    },

    props: {
        title: {
            requuired: true,
            type     : String
        },

        company: {

        },

        companyRole: {

        },

        onsite: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },

        zus: {
            type: Boolean,
            required: false,
            default: function () {
                return false;
            }
        },

        contacts: {
            requuired: true,
            type     : Array
        }
    },

    data: () => ({
        showAssignmentDialog: false,
    }),

    methods: {
        onAssign () {
            this.showAssignmentDialog = true;
        },

        onAssigned (selected) {
            this.$emit("assigned", {
                selected: selected,
                contacts: this.contacts
            })
        },

        onDissolve (contact) {
            this.$emit("dissolve", contact);
        }
    }
}
</script>

<style scoped>

.card-area {
    overflow-y: scroll;
    max-height: 815px;
    width: calc(100% + 8px);
    background-color: white;
}

</style>